import * as React from 'react';
import * as PropTypes from 'prop-types';
import {LinedSelect} from './lined-select';

export const Select = React.memo(
	({value, availableOptions, onValueChange, readOnly, ...restProps}) => {
		return (
			<LinedSelect
				value={value}
				availableOptions={availableOptions}
				onValueChange={onValueChange}
				readOnly={readOnly}
				{...restProps}
			/>
		);
	},
);

Select.propTypes = {
	onValueChange: PropTypes.func.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	availableOptions: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			text: PropTypes.string.isRequired,
		}),
	),
	readOnly: PropTypes.bool,
};

Select.defaultProps = {
	readOnly: false,
	availableOptions: [],
};
